// Module
var code = "<a data-bind=\"visible: true, click: Click, style: _style\" class=\"text-sm sps-btn sps-btn-outline btn-color-return return-button\"> <i class=\"fa fa-mail-reply-all\" align=\"center\"></i><span><!-- ko text: _labels.RETURN --><!-- /ko --></span> </a>";
// Exports
export default code;